require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tutorials-examples-microwave.json") })
        }
      }, "path---tutorials-examples-microwave");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tutorials-examples-microwave!./.cache/json/tutorials-examples-microwave.json
// module id = 777
// module chunks = 231608221292675